import BaseListPresenter from "../../../base/BaseListPresenter";

class SuppliersListPagePresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase,
    getCurrentUserUseCase,
  ) {
    super(view, findObjectUseCase, countObjectUseCase, deleteObjectUseCase);
    this.upsertUseCase = upsertUseCase;
    this.getCurrentUserUseCase = getCurrentUserUseCase;

    this.objects = [];
  }

  init() {
    const user = this.view.getCurrentUser();
    const clientId = this.view.getClientId();

    this.limit = 20;
    this.where = {
      client: {
        id: clientId || user.client?.id,
      },
    };
    this.search = {};
    this.filter = {};
    this.include = ["all"];
    this.keys = undefined; // if keys are specified, only those keys will be returned
    this.sort = { created: -1 };
    this.progress = true;
    this.reset();
  }

  createQuery() {
    const skip = (this.current - 1) * this.limit;
    const query = {
      limit: this.limit,
      skip: skip,
      where: { ...this.where, ...this.search, ...this.filter },
      include: this.include,
    };
    if (this.sort) {
      query.sort = this.sort;
    }
    const keys = this.keys || this.view.getKeys() || [];
    if (keys.length > 0) {
      query.keys = keys;
    }
    return query;
  }

  async findObjects() {
    const collection = this.view.getCollectionName();
    const query = this.createQuery();
    try {
      this.view.showProgress();
      this.findObjectUseCase.abort();
      const objects = await this.findObjectUseCase.execute(collection, query);
      this.objects = this.objects.concat(objects);
      this.view.setTotal(this.objects.length);
      this.view.setObjects(this.objects);
      this.hideProgress();
    } catch (error) {
      this.hideProgress();
      this.view.showError(error);
    }
    this.progress = false;
  }

  async onSubmit(object) {
    const collection = this.view.getCollectionName();
    try {
      await this.upsertUseCase.execute(collection, object);
      this.getObjects();
    } catch (error) {
      this.view.showError(error);
    }
  }

  async onSubmitModal(collection, object) {
    const updatedObject = { ...object };
    try {
      this.view.showProgress();

      await this.upsertUseCase.execute(collection, updatedObject);

      this.view.hideProgress();
      this.view.showSuccess("Data Added Successfully!");
    } catch (error) {
      this.view.showError(error);
    }
  }

  getMonths() {
    const year = new Date().getFullYear();
    const months = Array.from({ length: 12 }, (_, i) => {
      return new Intl.DateTimeFormat("en-US", { month: "long" }).format(
        new Date(year, i, 1),
      );
    });

    return months;
  }

  async updateBooleanFieldBulk(objects, field, value) {
    if (!this.upsertUseCase || !objects?.length) return;
    const collection = this.view.getCollectionName();
    try {
      for (const object of objects) {
        const id = object?.id ?? object?.objectId;
        if (!id) continue;
        await this.upsertUseCase.execute(collection, { id, [field]: value });
        if (typeof this.view.updateObjectInList === "function") {
          this.view.updateObjectInList(id, { ...object, [field]: value });
        }
      }
      if (typeof this.view.setSelected === "function") {
        this.view.setSelected([]);
      }
      if (typeof this.view.showSuccessToast === "function") {
        this.view.showSuccessToast(
          objects.length === 1
            ? "Updated successfully"
            : `${objects.length} items updated successfully`
        );
      }
    } catch (error) {
      this.view.showError(error);
    }
  }
}

export default SuppliersListPagePresenter;
